import { Box, Paper } from 'lucid-components-react';
import React, { ReactNode } from 'react';

import { mqMax, mqMin } from 'theme/base';
import { LucidTheme } from 'types/types';

import './footer-card.scss';

interface Props {
  children: ReactNode;
}

const FooterCard = ({ children }: Props) => (
  <Box
    className="footer-card"
    css={(theme: LucidTheme) => ({
      label: 'footerCard',
      zIndex: theme.zIndices[2],
      position: 'relative',
      width: '100%',
      marginTop: `calc(-${theme.space[10]}px - ${theme.space[5]}px)`,
      [mqMax.tabletSmall]: {
        marginTop: theme.space[0]
      }
    })}
  >
    <Box
      css={(theme: LucidTheme) => ({
        label: 'wrapper',
        maxWidth: '90em',
        padding: `0 ${theme.space[10]}px ${theme.space[4]}px`,
        margin: '0 auto',
        [mqMax.tabletLandscape]: {
          padding: `${theme.space[8]}px 0`,
          margin: `0 ${theme.space[8]}px`
        },
        [mqMax.tabletSmall]: {
          padding: `${theme.space[8]}px 0`,
          margin: `${theme.space[5]}px ${theme.space[5]}px 0`,
          borderTop: `1px solid ${theme.colors.coolGrey[5]}`
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '130px',
          left: 0,
          width: '100%',
          height: 'calc(100% - 125px)',
          backgroundColor: theme.colors.coolGrey[100],
          [`@media only screen and (max-width: ${theme.breakpoints.tabletSmall})`]: {
            backgroundColor: 'transparent'
          },
          '&:not(:lang(en))': {
            [`@media only screen and (max-width: ${theme.breakpoints.tabletLandscape})`]: {
              padding: `0 ${theme.space[5]}px`
            },
            [`@media only screen and (max-width: ${theme.breakpoints.tabletSmall})`]: {
              padding: `${theme.space[8]}px 0 0`,
              margin: `${theme.space[8]}px ${theme.space[5]}px`
            }
          }
        }
      })}
    >
      <Paper
        className="card--offset-bottom-md"
        css={(theme: LucidTheme) => ({
          label: 'card',
          position: 'relative',
          [mqMin.tabletSmall]: {
            zIndex: theme.zIndices[2]
          }
        })}
      >
        <Box className="card__contents card__contents--lg layout">
          {children}
        </Box>
      </Paper>
    </Box>
  </Box>
);

export default FooterCard;
